import { Component, OnInit } from '@angular/core';
import { NewsalesandvolumeService } from './newsalesandvolume.service';
import { environment } from 'src/environments/environment.prod';
@Component({
  selector: 'app-newsalesandvolume',
  templateUrl: './newsalesandvolume.component.html',
  styleUrls: ['./newsalesandvolume.component.scss']
})
export class NewsalesandvolumeComponent implements OnInit {
  newsalesandvolumeData: any;
  loading: boolean = true;
  sourceDropdownOptions: any[];
  selectedSource: string;
  filteredData: any[] = [];
  email: any;

  showSalesDialog(item: any) {
    this.closeAllModals();
    item.new_sales = true;
  }

  showVolumeDialog(item: any) {
    this.closeAllModals();
    item.new_volume = true;
  }

  closeAllModals() {
    for (const item of this.filteredData) {
      item.new_sales = false;
      item.new_volume = false;
    }
  }

  constructor(private NewsalesandvolumeService: NewsalesandvolumeService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getNewSalesVolumeData();

    this.sourceDropdownOptions = [
      { label: 'Some Are Zero', value: 'Some Are Zero' },
      { label: 'All Are Zero', value: 'All Are Zero' },
    ];

    this.selectedSource = 'Some Are Zero';
    console.log("selectedsource", this.selectedSource);
  }

  filterData() {
    if (this.selectedSource === 'Some Are Zero') {
      this.filteredData = this.newsalesandvolumeData.filter(item => item.all_sale_volumn_or_not === 'Some Are Zero');
      console.log("filtered data some", this.filteredData);
    } else if (this.selectedSource === 'All Are Zero') {
      this.filteredData = this.newsalesandvolumeData.filter(item => item.all_sale_volumn_or_not === 'All Are Zero');
      console.log("filtered data all", this.filteredData);
    }
  }

  getNewSalesVolumeData() {
    this.NewsalesandvolumeService.getSalesAndVolumeZeroData(this.email).subscribe((response) => {
      this.newsalesandvolumeData = response["data"];
      console.log("resss", this.newsalesandvolumeData);
      this.filterData();
      this.loading = false;
    });
  }

  getStrengthsHeaderText(data: any): string {
    if (!data || !data['value'] || !data['value']['Strengths (mg)']) {
      return '';
    }

    const firstEntry = data['value'];
    return firstEntry ? Object.keys(firstEntry)[0] : '';
  }


  getYears(strengths: any[]): string[] {
    if (!strengths || strengths.length === 0) {
      return [];
    }

    const yearsData = strengths[0];
    return yearsData ? Object.keys(yearsData[Object.keys(yearsData)[0]]) : [];
  }



  redirectToOtherPage(brand_name, nda) {
    window.open(`${environment.ip}#/filessalesandvolume?brand_name=${brand_name}&nda=${nda}`, '_blank');
    // window.open(`http://3.111.249.237/#/filessalesandvolume?brand_name=${brand_name}&nda=${nda}`, '_blank');
    // window.open(`http://3.111.249.237/#/filessalesandvolume?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }
}
